<div class="page">
<div class="container" fxLayout="column" fxLayoutAlign="space-between center">
    <div class="img-logo">
        <img src="./../../assets/logo.png">
    </div>


    <mat-card class="card">
        <h1>
            <a fragment="about" (click)="navigateToSection('about')">About</a>
        </h1>
        <div id="about">
            <p>
                Resources from the Jerusalem Corpus of Emergent Modern Hebrew
            </p>
        </div>
    </mat-card>

    <button mat-raised-button>
        <a href="http://jemh.researchsoftwarehosting.org/annis/">
            Go to Corpus
        </a>
    </button>
</div></div>